/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BalanceResponse,
  FakerSmsPageDTO,
  GetFakerSmsLogsParams
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Returns paginated mock SMS messages that were logged for this institution
 * @summary Get faker SMS logs
 */
export const getFakerSmsLogs = (
    params?: GetFakerSmsLogsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FakerSmsPageDTO>(
      {url: `/api/frontend/sms/faker-logs`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetFakerSmsLogsInfiniteQueryKey = (params?: GetFakerSmsLogsParams,) => {
    return [
    'infinite', `/api/frontend/sms/faker-logs`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetFakerSmsLogsQueryKey = (params?: GetFakerSmsLogsParams,) => {
    return [
    `/api/frontend/sms/faker-logs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetFakerSmsLogsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getFakerSmsLogs>>>, TError = unknown>(params?: GetFakerSmsLogsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFakerSmsLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFakerSmsLogsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFakerSmsLogs>>> = ({ signal }) => getFakerSmsLogs(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFakerSmsLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFakerSmsLogsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getFakerSmsLogs>>>
export type GetFakerSmsLogsInfiniteQueryError = unknown


export function useGetFakerSmsLogsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFakerSmsLogs>>>, TError = unknown>(
 params: undefined |  GetFakerSmsLogsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFakerSmsLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFakerSmsLogs>>,
          TError,
          Awaited<ReturnType<typeof getFakerSmsLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFakerSmsLogsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFakerSmsLogs>>>, TError = unknown>(
 params?: GetFakerSmsLogsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFakerSmsLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFakerSmsLogs>>,
          TError,
          Awaited<ReturnType<typeof getFakerSmsLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFakerSmsLogsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFakerSmsLogs>>>, TError = unknown>(
 params?: GetFakerSmsLogsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFakerSmsLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get faker SMS logs
 */

export function useGetFakerSmsLogsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFakerSmsLogs>>>, TError = unknown>(
 params?: GetFakerSmsLogsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFakerSmsLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFakerSmsLogsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetFakerSmsLogsQueryOptions = <TData = Awaited<ReturnType<typeof getFakerSmsLogs>>, TError = unknown>(params?: GetFakerSmsLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFakerSmsLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFakerSmsLogsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFakerSmsLogs>>> = ({ signal }) => getFakerSmsLogs(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFakerSmsLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFakerSmsLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getFakerSmsLogs>>>
export type GetFakerSmsLogsQueryError = unknown


export function useGetFakerSmsLogs<TData = Awaited<ReturnType<typeof getFakerSmsLogs>>, TError = unknown>(
 params: undefined |  GetFakerSmsLogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFakerSmsLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFakerSmsLogs>>,
          TError,
          Awaited<ReturnType<typeof getFakerSmsLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFakerSmsLogs<TData = Awaited<ReturnType<typeof getFakerSmsLogs>>, TError = unknown>(
 params?: GetFakerSmsLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFakerSmsLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFakerSmsLogs>>,
          TError,
          Awaited<ReturnType<typeof getFakerSmsLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFakerSmsLogs<TData = Awaited<ReturnType<typeof getFakerSmsLogs>>, TError = unknown>(
 params?: GetFakerSmsLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFakerSmsLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get faker SMS logs
 */

export function useGetFakerSmsLogs<TData = Awaited<ReturnType<typeof getFakerSmsLogs>>, TError = unknown>(
 params?: GetFakerSmsLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFakerSmsLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFakerSmsLogsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Deletes all mock SMS messages for this institution
 * @summary Clear faker SMS logs
 */
export const clearFakerSmsLogs = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/frontend/sms/faker-logs`, method: 'DELETE'
    },
      options);
    }
  


export const getClearFakerSmsLogsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearFakerSmsLogs>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof clearFakerSmsLogs>>, TError,void, TContext> => {

const mutationKey = ['clearFakerSmsLogs'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearFakerSmsLogs>>, void> = () => {
          

          return  clearFakerSmsLogs(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClearFakerSmsLogsMutationResult = NonNullable<Awaited<ReturnType<typeof clearFakerSmsLogs>>>
    
    export type ClearFakerSmsLogsMutationError = unknown

    /**
 * @summary Clear faker SMS logs
 */
export const useClearFakerSmsLogs = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearFakerSmsLogs>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearFakerSmsLogs>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getClearFakerSmsLogsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns current SMS credit balance for this institution
 * @summary Get SMS balance
 */
export const getSmsBalance1 = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<BalanceResponse>(
      {url: `/api/frontend/sms/balance`, method: 'GET', signal
    },
      options);
    }
  



export const getGetSmsBalance1InfiniteQueryKey = () => {
    return [
    'infinite', `/api/frontend/sms/balance`
    ] as const;
    }

export const getGetSmsBalance1QueryKey = () => {
    return [
    `/api/frontend/sms/balance`
    ] as const;
    }

    
export const getGetSmsBalance1InfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getSmsBalance1>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSmsBalance1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSmsBalance1InfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSmsBalance1>>> = ({ signal }) => getSmsBalance1(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSmsBalance1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSmsBalance1InfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getSmsBalance1>>>
export type GetSmsBalance1InfiniteQueryError = unknown


export function useGetSmsBalance1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getSmsBalance1>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSmsBalance1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSmsBalance1>>,
          TError,
          Awaited<ReturnType<typeof getSmsBalance1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSmsBalance1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getSmsBalance1>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSmsBalance1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSmsBalance1>>,
          TError,
          Awaited<ReturnType<typeof getSmsBalance1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSmsBalance1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getSmsBalance1>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSmsBalance1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get SMS balance
 */

export function useGetSmsBalance1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getSmsBalance1>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSmsBalance1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSmsBalance1InfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetSmsBalance1QueryOptions = <TData = Awaited<ReturnType<typeof getSmsBalance1>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmsBalance1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSmsBalance1QueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSmsBalance1>>> = ({ signal }) => getSmsBalance1(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSmsBalance1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSmsBalance1QueryResult = NonNullable<Awaited<ReturnType<typeof getSmsBalance1>>>
export type GetSmsBalance1QueryError = unknown


export function useGetSmsBalance1<TData = Awaited<ReturnType<typeof getSmsBalance1>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmsBalance1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSmsBalance1>>,
          TError,
          Awaited<ReturnType<typeof getSmsBalance1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSmsBalance1<TData = Awaited<ReturnType<typeof getSmsBalance1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmsBalance1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSmsBalance1>>,
          TError,
          Awaited<ReturnType<typeof getSmsBalance1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSmsBalance1<TData = Awaited<ReturnType<typeof getSmsBalance1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmsBalance1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get SMS balance
 */

export function useGetSmsBalance1<TData = Awaited<ReturnType<typeof getSmsBalance1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmsBalance1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSmsBalance1QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




